export var OrdersStatus;
(function (OrdersStatus) {
    OrdersStatus[OrdersStatus["Initial"] = 0] = "Initial";
    OrdersStatus[OrdersStatus["Getting"] = 1] = "Getting";
    OrdersStatus[OrdersStatus["GetSuccess"] = 2] = "GetSuccess";
    OrdersStatus[OrdersStatus["GettingStatus"] = 3] = "GettingStatus";
    OrdersStatus[OrdersStatus["GetStatusSuccess"] = 4] = "GetStatusSuccess";
    OrdersStatus[OrdersStatus["Migrating"] = 5] = "Migrating";
    OrdersStatus[OrdersStatus["MigrateSuccess"] = 6] = "MigrateSuccess";
    OrdersStatus[OrdersStatus["Reloading"] = 7] = "Reloading";
    OrdersStatus[OrdersStatus["ReloadSuccess"] = 8] = "ReloadSuccess";
    OrdersStatus[OrdersStatus["SavingOrder"] = 9] = "SavingOrder";
    OrdersStatus[OrdersStatus["SaveOrderSuccess"] = 10] = "SaveOrderSuccess";
    OrdersStatus[OrdersStatus["SavingOrderRedeem"] = 11] = "SavingOrderRedeem";
    OrdersStatus[OrdersStatus["SaveOrderRedeemSuccess"] = 12] = "SaveOrderRedeemSuccess";
    OrdersStatus[OrdersStatus["SavingNotes"] = 13] = "SavingNotes";
    OrdersStatus[OrdersStatus["SaveNotesSuccess"] = 14] = "SaveNotesSuccess";
    OrdersStatus[OrdersStatus["SavingOrderItem"] = 15] = "SavingOrderItem";
    OrdersStatus[OrdersStatus["SaveOrderItemSuccess"] = 16] = "SaveOrderItemSuccess";
    OrdersStatus[OrdersStatus["DeletingOrderItem"] = 17] = "DeletingOrderItem";
    OrdersStatus[OrdersStatus["DeleteOrderItemSuccess"] = 18] = "DeleteOrderItemSuccess";
    OrdersStatus[OrdersStatus["DeletingPetFromOrder"] = 19] = "DeletingPetFromOrder";
    OrdersStatus[OrdersStatus["DeletePetFromOrderSuccess"] = 20] = "DeletePetFromOrderSuccess";
    OrdersStatus[OrdersStatus["VerifyingOutdated"] = 21] = "VerifyingOutdated";
    OrdersStatus[OrdersStatus["VerifyOutdatedSuccess"] = 22] = "VerifyOutdatedSuccess";
    OrdersStatus[OrdersStatus["NotFound"] = 23] = "NotFound";
    OrdersStatus[OrdersStatus["Unprocessable"] = 24] = "Unprocessable";
    OrdersStatus[OrdersStatus["Error"] = 25] = "Error";
})(OrdersStatus || (OrdersStatus = {}));
